<template>
  <div>
    <div class="gkmg-ag-grid-filter-area" :style="filterFieldStyle">
      <div class="gkmg-ag-grid-filter-title">
        {{ columnLabel }}
      </div>
      <div class="row" v-for="(option, key) in selectOptions" :key="key">
        <img
          v-show="isChecked(option.value)"
          :src="filterChecked"
          @click.stop.prevent="filterRow(option.value, true)"
        />
        <img
          v-show="!isChecked(option.value)"
          :src="filterUnChecked"
          @click.stop.prevent="filterRow(option.value, false)"
        />
        <span class="gkmg-ag-grid-text">{{ option.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 入出港予定一覧表のフィルター用コンポーネント
 * @parent O.DestinationWorkList
 */
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers(
  "gkmgPortMasterDestinationWork",
);

export default {
  name: "M.FilterSelect",
  data() {
    return {
      filterChecked: require("@/assets/images/icons/gkmg-port-master/filter_checked.svg"),
      filterUnChecked: require("@/assets/images/icons/gkmg-port-master/filter_unchecked.svg"),
      checkedLabels: {},
      selectOptions: [],
    };
  },
  methods: {
    /**
     * 入力内容を更新し、フィルターかける
     */
    filterRow(keyword, isFilterExclude) {
      // this.params.context.componentParentで親コンポーネントにアクセスできる
      this.params.context.componentParent.updateFilterRule(
        this.filterKey,
        keyword,
        isFilterExclude,
      );
      this.setCheckBoxState(keyword); // checkboxの見た目を更新する

      this.params.context.componentParent.updateFilterState(
        this.columnKey,
        false,
        true,
      );
    },
    setCheckBoxState(key) {
      if (Object.hasOwn(this.checkedLabels, key)) {
        this.checkedLabels = {
          ...this.checkedLabels,
          [key]: !this.checkedLabels[key],
        };
      } else {
        this.checkedLabels = {
          ...this.checkedLabels,
          [key]: true,
        };
      }
    },
    initSelectOptions() {
      this.selectOptions = this.params.context.componentParent.getSelectOptions(
        this.columnKey,
      );

      this.checkedLabels = {};
      const filterRule = this.filterRuleMerged[this.filterKey];
      this.selectOptions.forEach((el) => {
        const { value } = el;
        this.checkedLabels[value] = filterRule[value];
      });
    },
    isChecked(key) {
      return this.checkedLabels[key];
    },
  },
  computed: {
    ...mapState({
      destinationWorkTasksMap: (state) => state.destinationWorkTasksMap,
      masterMap: (state) => state.masterMap,
    }),
    ...mapGetters({
      selectedDate: "selectedDate",
      filterRuleMerged: "filterRuleMerged",
    }),
    columnKey() {
      return this.params.colDef.field;
    },
    filterKey() {
      return this.params.colDef.filterKey;
    },
    columnLabel() {
      return this.params.colDef.headerName;
    },
    filterFieldStyle() {
      if (!this.selectOptions) return {};
      if (!this.selectOptions.length) return {};
      return {
        height: `${50 + this.selectOptions.length * 30}px`,
      };
    },
  },
  watch: {
    selectedDate() {
      this.initSelectOptions(); // 表示する日時が変わったら選択肢の初期化
    },
    destinationWorkTasksMap: {
      handler() {
        this.initSelectOptions(); // 表示する一覧表のデータが変わったら選択肢の初期化
      },
      deep: true,
    },
    masterMap: {
      handler() {
        this.initSelectOptions(); // 島などのマスタデータが変わったら選択肢の初期化
      },
      deep: true,
    },
  },
  created() {
    this.initSelectOptions(); // コンポーネント初期化時に選択肢の初期化
  },
};
</script>

<style scoped>
.gkmg-ag-grid-filter-title {
  color: #f2f2f2;
  font-family: "Hiragino kaku Gothic Pron";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}
.gkmg-ag-grid-filter-area {
  width: 150px;
  background-color: #2d2d2d;
  color: #f2f2f2;
}

.row {
  display: flex;
}

.gkmg-ag-grid-text {
  left: 30px;
  width: 140px;
  height: 30px;
  padding: 8px 0px 0px 5px;
  color: #f2f2f2;
  font-family: "Hiragino kaku Gothic Pron";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 15px;
}
</style>
